/**
 * String for `catch (e)` values (`e` is `unknown` in strict TS). Avoids `String(object)` → `[object Object]`.
 */
export function formatUnknownError(e: unknown): string {
  if (e instanceof Error) return e.message;
  if (typeof e === "string") return e;
  if (e != null && typeof e === "object") {
    const m = (e as { message?: unknown }).message;
    if (typeof m === "string" && m) return m;
    try {
      return JSON.stringify(e);
    } catch {
      return "[unserializable error]";
    }
  }
  if (e == null) return e === undefined ? "undefined" : "null";
  const t = typeof e;
  if (t === "boolean") return String(e as boolean);
  if (t === "number") return String(e as number);
  if (t === "bigint") return `${e as bigint}n`;
  if (t === "symbol")
    return ((s: symbol) =>
      s.description ? `Symbol(${s.description})` : s.toString())(e as symbol);
  if (t === "function")
    return ((f: { name?: string }) =>
      f.name ? `[function ${f.name}]` : "[function]")(e as { name?: string });
  return "[unknown error]";
}
